"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { ValidDateModel } from "@/models/DiscountCoupon.model";
export let CardModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.cost_actual = 0;
    this.cost_money = 0;
    this.cost_official = 0;
    this.guid = "";
    this.left_count = 0;
    this.name = "";
    this.status = 0;
    this.status_desc = "";
    this.style = "";
    this.total_count = 0;
    this.type = "";
    this.good_specs = [];
    this.regions = [];
    this.scenes = [];
    this.valid_date = new ValidDateModel();
  }
};
CardModel.model = "vd_card";
CardModel = __decorateClass([
  Annotation.ModelMeta
], CardModel);
